import COUNTRIES_API from 'api/countries/v1'
import i18next from 'i18next'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'
import { GET_DATA } from 'modules/Countries/types'
import { actionSetData } from 'modules/Countries/actions'

function* getCountries({ payload }) {
  try {
    yield put(actionSetData({ loading: true }))

    const { response, error } = yield call(COUNTRIES_API.fetchData, {
      params: { ...payload },
    })

    if (error) {
      throw error
    }

    if (response) {
      yield put(actionSetData({ data: response.data, loaded: true }))
    }
  } catch (error) {
    const { form } = extractErrors(error.errors)

    if (form?.length) {
      yield put(
        notificationShow({
          type: 'error',
          message: i18next.t(form),
        }),
      )
    }
  } finally {
    yield put(actionSetData({ loading: false }))
  }
}

export default function* Sagas() {
  yield takeLatest(GET_DATA, getCountries)
}
